<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
	
		<el-table :data="grid_data" ref="myTable" height="calc(100vh - 220px)" border highlight-current-row 
		 @selection-change="(v)=>{sels = v}" style="width: 100%;">
		 <el-table-column prop="realName" label="用户姓名" width="100"></el-table-column>
			<el-table-column prop="logName" label="用户名" width="150"></el-table-column>
			<el-table-column prop="mobileNo" label="手机号" width="130"></el-table-column>
					<el-table-column prop="totalAnswerTimes" label="答题时长(秒）" width="135"></el-table-column>
					<el-table-column prop="totalScore" label="总得分" width="90" sortable></el-table-column>
						<el-table-column prop="errorNum" label="错误数" width="85" sortable></el-table-column>
					<el-table-column prop="okNum" label="正确数" width="85" sortable></el-table-column>
					<el-table-column prop="okRate" label="正确率" width="85" sortable></el-table-column>
					<el-table-column prop="addTime" label="开始做题时间" min-width="150" :formatter="$util.dateFormatEx"></el-table-column>
		</el-table>

		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="exportXls" size="small">导 出</el-button>
		</div>
	</el-dialog>

</template>
<script>
	export default {
		name: "addSave",
		props: ["showTitle", "dialogAddShow", "mid"],
		data() {
			return {
				grid_data:[]
			};
		},
		watch: {
			dialogAddShow: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.initData();
					}
				},
				deep: true
			}
		},
		methods: {
			initData() {
				let formData = this.$util.jsonToForm({matchId:this.mid});
				this.$axios.post("/exercise/getrankmatchuserlist",formData).then(res=>{
					this.grid_data=res.data.data;
				});
			},
			handleClose() {
				this.$emit("getVisible", false);
			},
			exportXls(){
			let excelColpropertys=[]
			let excelCollabels=[]
			this.$refs.myTable.columns.map(v=>{
				if(v.property!=undefined && v.property!='picUrl'){
					excelColpropertys.push(v.property)
					excelCollabels.push(v.label)
				}
			})
			let filters={matchId:this.mid}
			filters.propertys=encodeURI(excelColpropertys.join(','))
			filters.labels=encodeURI(excelCollabels.join(','))
			filters.isExport=1

			let params="";
			for(var key in filters){
				params+="&txt_"+key+"="+filters[key];
			}
			params+="&token="+localStorage.getItem("token")
			window.open(this.$axios.defaults.baseURL+"/exercise/rankmatchuser_exportxls?"+params.substring(1),"_blank");
		},
	},
		
	};
</script>

<style lang="less" scoped>

</style>

